<script lang="ts">
  import translationsStore from '../../../stores/translations.svelte'
  import videoStore from '../../../stores/video.svelte'
  import PauseSmallIcon from '../icons/PauseSmallIcon.svelte'
  import PlaySmallIcon from '../icons/PlaySmallIcon.svelte'
  import ReplayIcon from '../icons/ReplayIcon.svelte'
  import ControlBarButton from './ControlBarButton.svelte'
  import { CONTROL_BAR_BUTTON_TOOLTIP_POSITION } from './ControlBarButton.svelte'
  import type { ControlBarButtonProps } from './ControlBarButton.svelte'

  let {
    tooltipPosition = CONTROL_BAR_BUTTON_TOOLTIP_POSITION.CENTER,
  }: Pick<ControlBarButtonProps, 'tooltipPosition'> = $props()
</script>

<ControlBarButton
  tooltip={videoStore.state.isPlaying
    ? translationsStore.state.pause
    : videoStore.state.isEnded
      ? translationsStore.state.replay
      : translationsStore.state.play}
  {tooltipPosition}
  onclick={() => videoStore.state.videoController?.togglePlayPause()}
>
  {#if videoStore.state.isEnded}
    <ReplayIcon />
  {:else if videoStore.state.isPlaying}
    <PauseSmallIcon />
  {:else}
    <span class="block w-full h-full overflow-hidden relative">
      <span
        class="block absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-9"
      >
        <PlaySmallIcon />
      </span>
    </span>
  {/if}
</ControlBarButton>
